import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import DashboardViewPage from './DashboardViewPage';
import DashboardLiveMap from './DashboardLiveMap';

const DashboardPage = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}`}>
        <DashboardViewPage />
      </Route>
      <Route path={`${match.url}/livemap`}>
        <DashboardLiveMap />
      </Route>
    </Switch>
  );
};

export default DashboardPage;
